




































import { Vue, Component } from 'vue-property-decorator';
import { Icon, Popup, List, Toast } from 'vant';
import { vueCanvasPoster } from 'vue-canvas-poster';
import QRCode from 'qrcode';
import {
  getCommentsByTag,
  getCommentsCount,
  getUserHistoryComments,
  vote,
} from '../api';
import CommentItem from '../components/CommentItem.vue';
import { isWeiXin } from '@/common/ts/common';

Vue.use(Icon).use(Popup).use(List).use(Toast);

const VOTE_THROTTLE_DELAY = 600;
let voteThrottleTimer: any = null;

@Component({
  components: {
    CommentItem,
    vueCanvasPoster,
  },
})
export default class User extends Vue {
  allComments: any[] = [];
  loading = false;
  page = 1;
  finished = false;
  totalCount = 0;
  posterUrl = '';
  qrUrl = '';
  showModal = false;
  canvasConfig: any = null;

  async created() {
    this.getAllComments();
  }

  // 获取全部评论
  async getAllComments() {
    this.loading = true;
    let unionid = '';
    if (isWeiXin()) {
      unionid = localStorage.getItem('unionid') as string;
    }
    const ret = await getUserHistoryComments({
      page: this.page,
      unionid,
    });
    this.loading = false;
    if (ret.data.length) {
      this.page++;
    } else {
      this.finished = true;
    }
    this.allComments = [...this.allComments, ...ret.data];
  }
  onTagInCommentItemClick(tagItem: any) {
    this.$router.push(
      `comments-with-tag?tagId=${tagItem.id}&name=${tagItem.name}`,
    );
  }
  // 海报分享相关
  genQrCode() {
    const targetUrl = `${location.origin}${process.env.VUE_APP_PUBLIC_PATH}2021-your-wishes-for-chongqing-h5`;
    QRCode.toDataURL(
      targetUrl,
      {
        quality: 1,
        margin: 0,
        scale: 20,
      },
      (err: any, url: string) => {
        if (err) {
          console.log('err occur:', err);
        } else {
          this.qrUrl = url;
        }
      },
    );
  }
  genCanvas(commentItem: any) {
    this.genQrCode();
    // 开始绘制
    this.canvasConfig = {
      width: '675px',
      height: '1080px',
      background: '#fff',
      borderRadius: '20px',
      views: [
        {
          type: 'image',
          id: 'cover',
          url: require('../assets/banner.png'),
          css: {
            top: 0,
            left: 0,
            width: '675px',
            height: '333px',
            borderRadius: '20px',
          },
        },
        {
          type: 'image',
          id: 'texture',
          url: require('../assets/底花纹.png'),
          css: {
            top: ['0px', 'cover'],
            left: 0,
            width: '675px',
            height: '600px',
          },
        },
        {
          type: 'text',
          id: 'a',
          text: `${commentItem.username}正在上游新闻参加`,
          css: {
            top: ['30px', 'cover'],
            left: '30px',
            color: '#666',
            fontSize: '32px',
          },
        },
        {
          type: 'text',
          id: 'b',
          text: '@2021重庆.我的新期待',
          css: {
            top: ['90px', 'cover'],
            left: '337px',
            color: '#666',
            fontSize: '32px',
            align: 'center',
          },
        },
        {
          type: 'text',
          id: 'c',
          text: '请来留下您2021年的新期待吧！',
          css: {
            top: ['150px', 'cover'],
            left: '337px',
            color: '#666',
            fontSize: '28px',
            align: 'center',
          },
        },
        {
          type: 'text',
          id: 'd',
          text: `${(commentItem.tag as any[])
            .map((item) => `#${item.name}#`)
            .join(' ')}${commentItem.content}`,
          css: {
            top: ['220px', 'cover'],
            width: '615px',
            left: '30px',
            color: '#333',
            fontSize: '32px',
            lineHeight: '50px',
            maxLines: 4,
          },
        },
        {
          type: 'image',
          url: require('../assets/sy-logo.png'),
          id: 'sy-logo',
          css: {
            bottom: '275px',
            left: '337px',
            width: '112px',
            height: '22px',
            mode: 'aspectFill',
            align: 'center',
          },
        },
        {
          type: 'image',
          url: this.qrUrl,
          id: 'qr',
          css: {
            bottom: '100px',
            left: '337px',
            width: '160px',
            height: '160px',
            mode: 'aspectFill',
            align: 'center',
          },
        },
        {
          type: 'text',
          id: 'e',
          text: '扫一扫二维码参与活动',
          css: {
            bottom: '50px',
            left: '337px',
            color: '#666',
            fontSize: '28px',
            align: 'center',
          },
        },
      ],
    };
  }

  success(src: any) {
    // 设置img的src
    this.posterUrl = src;
    this.toggleModal();
  }
  fail(err: any) {
    console.log('poster gen failed:', err);
  }
  toggleModal() {
    this.showModal = !this.showModal;
  }
  async onVote(commentItemIndex: number) {
    if (voteThrottleTimer) {
      Toast('点赞手速不要太快哦');
      clearTimeout(voteThrottleTimer);
      // voteThrottleTimer = null;
    }
    voteThrottleTimer = setTimeout(async () => {
      const ret: any = await vote(this.allComments[commentItemIndex].commentId);
      if (ret.code === 200) {
        this.allComments[commentItemIndex].votes =
          Number(this.allComments[commentItemIndex].votes) + 1;
      }
      voteThrottleTimer = null;
      Toast(ret.msg);
    }, VOTE_THROTTLE_DELAY);
  }
}
